<template>
    <div>
        <div class="app" v-cloak>
            <keep-alive :include="include" :max="10">
                <router-view class="router" ref="router"></router-view>
            </keep-alive>
        </div>
        <Home v-if="home === true" />
        <Footer v-if="footer === true" />
        <PageLoading v-if="showLoading" />
    </div>
</template>
<script>
function isKeepAlive($route) {
    return $route.meta.keepAlive === undefined || $route.meta.keepAlive;
}

import Home from "@components/Home";
import Footer from "@components/Footer";
import PageLoading from "@components/PageLoading";
import { mapGetters } from "vuex";
import { openShareAll } from "@libs/wechat";
import { getShare } from "@api/public";
import { isWeixin } from "@utils/index";

export default {
    data() {
        return {
            transitionName: "fold-right",
            include: isKeepAlive(this.$route) ? [this.$route.name] : [],
            history: []
        };
    },
    provide() {
        return {
            app: this
        };
    },
    computed: {
        ...mapGetters(["footer", "home", "isLogin", 'showLoading'])
    },
    components: {
        Home,
        Footer,
        PageLoading,
    },
    watch: {
        $route(to, from) {
            const lastPath = this.history[this.history.length - 1] || {},
                { isReplace, isBack } = this.$router;

            if (lastPath.path === to.path) {
                this.transitionName = "fold-right";
                this.history.pop();
            } else {
                this.transitionName = "fold-left";
                if (!isReplace) this.history.push({ path: from.path, name: from.name });
            }

            if (isKeepAlive(to) && to.name !== "Login") {
                !this.include.includes(to.name) && this.include.push(to.name);
            }

            if (isKeepAlive(from) && isBack) {
                var index = this.include.indexOf(from.name);
                index !== -1 && this.include.splice(index, 1);
            }

            this.$router.isBack = false;
            this.$router.isReplace = false;

            console.log(this.transitionName, "change");
        }
    },
    mounted: function() {
        this.setOpenShare();
    },
    methods: {
        setOpenShare: function() {
            if (isWeixin()) {
                // getShare().then(res => {
                //   var data = res.data.data;
                //   var configAppMessage = {
                //     desc: data.synopsis,
                //     title: data.title,
                //     link: location.href,
                //     imgUrl: data.img
                //   };
                //   openShareAll(configAppMessage);
                // });
            }
        }
    }
}
window.onload = function() {
    document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    });
    var lastTouchEnd = 0;
    document.addEventListener('touchend', function(event) {
        var now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
            event.preventDefault();
        }
        lastTouchEnd = now;
    }, false);
    document.addEventListener('gesturestart', function(event) {
        event.preventDefault();
    });
}
</script>
<style lang="scss">
[v-cloak] {
    display: none !important;
}

.router {
    position: absolute;
    width: 100%;
}

.fold-left-enter-active {
    animation-name: fold-left-in;
    animation-duration: 0.5s;
}

.fold-left-leave-active {
    animation-name: fold-left-out;
    animation-duration: 0.5s;
}

@keyframes fold-left-in {
    0% {
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
    }

    10% {
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
    }

    100% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }
}

@keyframes fold-left-out {
    0% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }

    10% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }

    100% {
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
    }
}

.fold-right-enter-active {
    animation-name: fold-right-in;
    animation-duration: 0.5s;
}

.fold-right-leave-active {
    animation-name: fold-right-out;
    animation-duration: 0.5s;
}

@keyframes fold-right-in {
    0% {
        width: 100%;
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
    }

    10% {
        width: 100%;
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
    }

    100% {
        width: 100%;
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }
}

@keyframes fold-right-out {
    0% {
        width: 100%;
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }

    10% {
        width: 100%;
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }

    100% {
        width: 100%;
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
    }
}

.line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.l-1 {
    -webkit-line-clamp: 1;
}

.l-2 {
    -webkit-line-clamp: 2;
}

.l-3 {
    -webkit-line-clamp: 3;
}

.l-4 {
    -webkit-line-clamp: 4;
}

.no-show {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.no-show img {
    width: 150px;
    height: 200px;
}

.loading-more {
    text-align: center;
    height: 30px;
    color: #999999;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.row-flex {
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
}

.row-wrap {
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.row-column {
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
}

.row-between-center {
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -o-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: space-between;
}

.row-around-center {
    -webkit-align-items: center;
    align-items: center;
    justify-content: space-around;
    -webkit-justify-content: space-around;
}

.row-center-center {
    -webkit-align-items: center;
    align-items: center;
    justify-content: center;
    -webkit-justify-content: center;
}

.row-start-center {
    -webkit-align-items: center;
    align-items: center;
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
}

.row-end-center {
    -webkit-align-items: center;
    align-items: center;
    justify-content: flex-end;
    -webkit-justify-content: flex-end;
}

.text-color {
    color: #d01112 !important;
}

.bg-color {
    background: #d01112 !important;
}

.border-color {
    border: 1px solid #d01112 !important;
}

/**隐藏视频的下载和全屏状态 */
video::-webkit-media-controls-fullscreen-button {
    display: none;
}

/**可能不起作用 */
video::-webkit-media-controls-download-button {
    display: none;
}

video::-webkit-media-controls {
    overflow: hidden !important;
}

video::-webkit-media-controls-enclosure {
    width: calc(100% + 32px);
    margin-left: auto;
}

/**iphone安全区域*/
#footer {
    // height: calc(1rem +  constant(safe-area-inset-bottom)) !important;
    // height: calc(1rem +  env(safe-area-inset-bottom)) !important;
}
</style>